module.exports = __webpack_public_path__ + "static/loading-732b23430277b27f23a1d00902d56264.gif";